import { createContext, ReactNode, useContext } from 'react';

import { fuelOptions } from '~src/constants';
import { useFetchEnergyOptions } from '~src/hooks/graphql/useConstant';
import { EnergyOptions } from '~src/model';

export type EnergyOptionsContext = { options: EnergyOptions };

const energyOptionsContext = createContext<EnergyOptionsContext>({ options: fuelOptions });

export const useEnergyOptionsContext = () => useContext<EnergyOptionsContext>(energyOptionsContext);

export const EnergyOptionsContextProvider = ({ children }: { children?: ReactNode }) => {
  const options = useFetchEnergyOptions();

  return <energyOptionsContext.Provider value={{ options }}>{children}</energyOptionsContext.Provider>;
};

export const useEnergyOptions = () => useEnergyOptionsContext().options;
